import { ApiClient } from '../http/api_client';
import { MyCatalogRegisterJsEnv } from '../models/my_catalog_register/my_catalog_register_js_env';
import { FavoriteItemJsEnv, FavoriteItemParameter } from '../models/my_catalog_register/favorite_item_js_env';
import { Env } from '../env';
import { getSiteTypeValue } from '../models/js_env';

export class MyCatalogRegisterRepository {

  async getFavoriteFolderList(catalogItemCode: string, supplierId: string): Promise<MyCatalogRegisterJsEnv> {

    try {

      const response = await ApiClient.get(
        Env.SETTING.userPublicApi.urlBase +
        `api/attract/item/favoriteFolderList?siteType=${Env.SITE_TYPE}&catalogItemCode=${catalogItemCode}&itemSupplierId=${supplierId}`
      );

      return MyCatalogRegisterJsEnv.success(response);

    } catch (error) {

      return MyCatalogRegisterJsEnv.error(error);
    }
  }

  /// お気に入り商品更新
  async favoriteItem(
    supplierId: string,
    catalogItemCode: string,
    folderShareType: number,
    folderCode: number,
    folderManagerId: string,
  ): Promise<FavoriteItemJsEnv> {

    const parameter: FavoriteItemParameter
      = new FavoriteItemParameter(
        supplierId,
        catalogItemCode,
        folderShareType,
        folderCode,
        getSiteTypeValue(),
        folderManagerId,
      );

    try{
     /// 正常
      const response = await ApiClient.post(Env.SETTING.userPublicApi.urlBase + 'api/attract/item/favoriteItem', parameter);
      return FavoriteItemJsEnv.success(response);
    }catch(error) {
      /// エラー
      return FavoriteItemJsEnv.error(error.response);
    }
  }
}
